import { useEffect, useRef, useState } from "react"
import { Box, Card, CardContent, Stack, Typography } from "@mui/material"
import { infoSnackbar } from "lib/snackbar/info-snackbar"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function ScenarioCostSummaryHeader({ costResult, activeVariantName, variantCount, onSwitchVariant }) {
    const [pulsing, setPulsing] = useState(false)
    const prevVariantName = useRef(activeVariantName)

    useEffect(pulseOnChange, [activeVariantName])

    return (
        <>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="h6">Scenario Summary</Typography>
                <If value={activeVariantName && variantCount >= 2}>
                    <Box
                        data-cy="active-variant-indicator"
                        onClick={onSwitchVariant}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            cursor: "pointer",
                            px: 1.5,
                            py: 0.75,
                            borderRadius: 1,
                            transition: "background-color 0.6s ease",
                            backgroundColor: pulsing ? "#DEF2F4" : "transparent",
                            "&:hover": { backgroundColor: "#DEF2F4" },
                        }}
                    >
                        <Iconify icon="mdi:source-branch" sx={{ fontSize: 18, color: "text.secondary" }} />
                        <Typography color="text.secondary" sx={{ fontSize: 16 }}>
                            Viewing variant:
                        </Typography>
                        <Typography color="text.primary" fontWeight={600} sx={{ fontSize: 16 }}>
                            {activeVariantName}
                        </Typography>
                        <Iconify icon="mdi:swap-horizontal" sx={{ fontSize: 20, color: "primary.main" }} />
                    </Box>
                </If>
            </Stack>

            <If value={isZeroTaskScenario()}>
                <Card>
                    <CardContent>
                        <Stack spacing={2} alignItems="center" sx={{ py: 4 }}>
                            <Iconify icon="mdi:clipboard-text-off-outline" sx={{ fontSize: 48, opacity: 0.3 }} />
                            <Typography variant="body1" color="text.secondary">
                                This regime has no tasks to cost.
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Add tasks to the regime and recalculate.
                            </Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </If>
        </>
    )

    function pulseOnChange() {
        if (prevVariantName.current === activeVariantName) return undefined
        prevVariantName.current = activeVariantName
        setPulsing(true)
        infoSnackbar(`Switched to variant: ${activeVariantName}`)
        const timer = setTimeout(stopPulsing, 600)
        return () => clearTimeout(timer)
    }

    function stopPulsing() {
        setPulsing(false)
    }

    function isZeroTaskScenario() {
        return costResult && costResult.taskCount === 0
    }
}
